import { logRunTimeError, parseStackTrace } from '@/utils/globalErrorHandler';
import { useErrorStore } from '@/store';
import type { ErrorInfo } from '@/types/error';
import { useEffect } from 'react';
import { useLocation, useNavigate, useRouteError } from 'react-router';

const RouteErrorHandler = () => {
	const error = useRouteError();
	const navigate = useNavigate();
	const location = useLocation();
	const { setError } = useErrorStore();

	useEffect(() => {
		// Navigate to error boundary page
		if (location.pathname !== '/error-boundary') {
      let errorInfo: ErrorInfo = {
        message: (error as Error).message || 'frontend error',
        stack: (error as Error).stack,
        name: (error as Error).name, // TypeError, ReferenceError, etc.
        cause: (error as any).cause, // Error cause (if available)
        fileName: (error as any).fileName, // Source file (Firefox)
        lineNumber: (error as any).lineNumber, // Line number (Firefox)
        columnNumber: (error as any).columnNumber, // Column number (Firefox)
        timestamp: new Date().toISOString(),
        pathname: location.pathname,
        type: 'frontend',
        stackTrace: parseStackTrace((error as Error).stack),
        userAgent: navigator.userAgent,
        href: window.location.href,
        search: location.search,
        hash: location.hash,
      };

      // Save error to store
      setError(errorInfo);
      // Log comprehensive error information
      logRunTimeError(errorInfo);

			navigate('/error-boundary');
		}
	}, [error, navigate, setError]);

	return null;
};

export default RouteErrorHandler;

